import { Form, InputNumber } from "antd";
import fieldDataTypes from "common/data/fieldDataTypes";
import CypressTestIds from "../../../cypress/CypressTestIds";

export default ({ selectedFieldRow, dataType, readOnly, getFormErrors }) => (
    <Form.Item
        label="Max Length"
        name={["fields", selectedFieldRow.name, "max"]}
        initialValue={fieldDataTypes[dataType].max}
        rules={[
            // Disallow zero when field is required
            ({ getFieldValue }) => ({
                validator(_, value) {
                    const isRequired = getFieldValue(["fields", selectedFieldRow.name, "isRequired"]);
                    if (isRequired && value === 0) {
                        return Promise.reject(new Error("Max Length cannot be 0 for required fields."));
                    }
                    return Promise.resolve();
                },
            }),
            ({ getFieldValue }) => ({
                validator(_, value) {
                    if (value >= getFieldValue(["fields", selectedFieldRow.name, "min"])) {
                        return Promise.resolve();
                    }
                    return Promise.reject(new Error("Max Length should be greater than or equal to Min Length."));
                },
            }),
        ]}
        {...getFormErrors(`fields.${selectedFieldRow.name}.max`)}
    >
        <InputNumber
            data-testid={CypressTestIds.SCHEMA_MAX_LENGTH_PROPERTY_INPUT}
            type="number"
            readOnly={readOnly}
            // Allow 0 when field is not required; validators will block 0 when required
            min={0}
            max={fieldDataTypes[dataType].max}
        ></InputNumber>
    </Form.Item>
);
